import { useTranslation } from "providers/i18n"
import {
  Typography,
  CardMedia,
  CardContent,
  Stack,
  Box,
  useTheme,
  Card,
} from "@mui/material"
import { LocationIcon } from "components/icons"
import dayjs from "config/dayjs"
import { getDisplayDateTime } from "../../../utils/date"
import { getFeatureDetail } from "../../../utils/feature"
import { LocationInfo } from "../features/LocationInfo"

export const VerticalEventCard = (props) => {
  const { event } = props
  const { t } = useTranslation()
  const { properties } = event
  const startDate = dayjs(properties?.start_date)
  const endDate = dayjs(properties?.end_date)

  const { name } = getFeatureDetail(event)

  const theme = useTheme()
  const { styleOverrides } = theme.components?.[`VerticalEventCard`] || {}
  const {
    root,
    cardContent,
    cardMedia,
    cardTitle,
    iconContainer,
    locationInfoContainer,
  } = styleOverrides

  return (
    <Card sx={root}>
      <CardMedia
        sx={cardMedia}
        component="img"
        image={properties.cover_image?.url}
      />
      <CardContent sx={cardContent}>
        <Stack spacing={1.25}>
          <Typography component="p" variant="subTitle" color="text.secondary">
            {getDisplayDateTime(startDate, endDate)}
          </Typography>
          <Typography
            sx={cardTitle}
            variant="subTitle"
            component="div"
            color="text.primary"
          >
            {t(name)}
          </Typography>
        </Stack>
        {properties.feature && (
          <Box sx={locationInfoContainer}>
            <Box sx={iconContainer} color="text.secondary">
              <LocationIcon />
            </Box>
            <LocationInfo
              feature={event}
              component="p"
              variant="subTitle"
              color="text.secondary"
            />
          </Box>
        )}
      </CardContent>
    </Card>
  )
}
